<template>
  <Headers :mc="prop.mc" :acc="prop.acc"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <div v-if="!loading" :class="[deviceType, 'landingContainer']">
      <div :class="[deviceType, 'leftContainer']">
        <img
          class="path-65"
          :class="[deviceType, 'start_logo']"
          style="width: 100%"
          src="../../../../assets/icons/LandingPic.svg"
        />
      </div>
      <div :class="[deviceType, 'rightContainer']">
        <div :class="[deviceType, 'title']">
          {{ t("ccOnBoarding.resume.landingTitle") }}
        </div>
        <div :class="[deviceType, 'title2']">
          {{ t("ccOnBoarding.resume.landingTitle2") }}
        </div>
        <div class="container1">
          <div class="desc1">{{ t("ccOnBoarding.resume.landingDesc") }}</div>
          <div class="desc2">
            <img
              style="width: 12px; height: 12px"
              class="path-65"
              src="../../../../assets/icons/tick.svg"
            />{{ t("ccOnBoarding.resume.landingDesc2") }}
          </div>
          <div class="desc2">
            <img
              style="width: 12px; height: 12px"
              class="path-65"
              src="../../../../assets/icons/tick.svg"
            />{{ t("ccOnBoarding.resume.landingDesc3") }}
          </div>
        </div>
        <div :class="[deviceType, 'buttoncontainer']">
          <button :class="[deviceType, 'right-button']" @click="jump('start')">
            {{ t("ccOnBoarding.resume.buttonStart") }}
          </button>
          <div :class="[deviceType, 'sub_buttoncontainer']">
            <button
              :class="[deviceType, 'left-button']"
              @click="jump('resume')"
              :disabled="prop.type == 'CR_SL' ? true : false"
            >
              {{ t("ccOnBoarding.resume.buttonResume") }}
            </button>
            <button
              :class="[deviceType, 'left-button']"
              @click="jump('documentResubmission')"
              :disabled="prop.type == 'CR_SL' ? true : false"
            >
              {{ t("ccOnBoarding.resume.buttonDocResubmission") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <div :class="[deviceType, 'retrieveContainer']">
        <div class="text-center flex-container">
          <br />
          <div class="spinner-border" role="status">
            <span class="sr-only">{{
              t("ccOnBoarding.uploadDocument.loading2")
            }}</span>
          </div>
          <br />
          <br />
          <p class="loading">
            <b>{{ t("ccOnBoarding.resume.retrieving") }}</b>
          </p>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
  <PopupMessage
    name="none"
    :type="''"
    :header="'draftFound'"
    v-if="popoutDraftFound"
    :popup="true"
    @resumeApplication="resumeApplication"
    @startNewApplication="startNewApplication"
  >
  </PopupMessage>
</template>

<script setup lang="ts">
import i18n from "@/plugin/i18n";
import { ref, inject } from "vue";
import Headers from "./../components/Headers.vue";
import PopupMessage from "./../components/PopupMessage.vue";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { useRouter } from "vue-router";

const deviceType = inject("deviceType");
const { t } = i18n.global;
const popoutDraftFound = ref(false);

const prop = defineProps({
  type: {
    type: String,
  },
  resumeInfo: {
    type: Object,
    required: true,
  },
  ccFormValue: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
  },
  resumeDraftData: {
    type: Object,
    required: true,
  },
  mc: {
    type: String,
  },
  acc: {
    type: String,
  },
});

const router = useRouter();
const emit = defineEmits(["jumpStep", "submit", "newApplication", "overlay"]);

const jump = (status: string) => {
  if (
    prop.type == "CR_SL" &&
    (status == "resume" || status == "documentResubmission")
  ) {
    return;
  } else if (status == "documentResubmission") {
    emit("jumpStep", 201, "", 4);
  } else if (prop.type == "FINPLUS") {
    emit("overlay");
    const requestModel2 = {
      idTypeCode: prop.resumeInfo.idType,
      idNo: prop.resumeInfo.idNo,
      email: prop.resumeInfo.email,
      mobileNo: prop.resumeInfo.countryCode + prop.resumeInfo.mobileNo,
      recruiterCode: "",
    };
    MasterService.fetchRecords(requestModel2)
      .then((res) => {
        if (res.status == 200) {
          if (status == "start") {
            if (res.data.responseModel.draftData > 0) {
              for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
                prop.resumeDraftData.push({
                  branchCode: res.data.responseModel.cardList[i].branchCode,
                  cardId: res.data.responseModel.cardList[i].cardId,
                  cardType: res.data.responseModel.cardList[i].cardType,
                  createdDate: res.data.responseModel.cardList[i].createdDate,
                  progress: res.data.responseModel.cardList[i].progress,
                  type: res.data.responseModel.cardList[i].type,
                  reference: res.data.responseModel.cardList[i].refNo,
                  webFormRequestId:
                    res.data.responseModel.cardList[i].webFormRequestId,
                });
              }
              emit("overlay");
              popoutDraftFound.value = true;
            } else {
              // no resume draft
              const requestModel = {
                idType: prop.resumeInfo.idType,
                idNo: prop.resumeInfo.idNo,
                mobileCountryCode: prop.resumeInfo.countryCode,
                mobileNumber: prop.resumeInfo.mobileNo,
                emailAddress: prop.resumeInfo.email,
              };
              MasterService.searchCIF(requestModel)
                .then((res) => {
                  if (res.status == 200) {
                    emit("overlay");
                    if (res.data.responseModel.cifVerify == "true") {
                      // existing customer
                      prop.ccFormValue.cifNo = res.data.responseModel.cifNo;
                      emit("submit");
                    } else {
                      // non-existing customer
                      emit("newApplication");
                      emit("jumpStep", 1, "", 4);
                    }
                  }
                })
                .catch((e) => {
                  emit("newApplication");
                  emit("jumpStep", 1, "", 4);
                });
            }
          } else {
            // resume
            emit("overlay");
            if (res.data.responseModel.draftData == 0)
              emit("jumpStep", 104, "", 4);
            else {
              for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
                prop.resumeDraftData.push({
                  branchCode: res.data.responseModel.cardList[i].branchCode,
                  cardId: res.data.responseModel.cardList[i].cardId,
                  cardType: res.data.responseModel.cardList[i].cardType,
                  createdDate: res.data.responseModel.cardList[i].createdDate,
                  progress: res.data.responseModel.cardList[i].progress,
                  type: res.data.responseModel.cardList[i].type,
                  reference: res.data.responseModel.cardList[i].refNo,
                  webFormRequestId:
                    res.data.responseModel.cardList[i].webFormRequestId,
                  recruiterName:
                    res.data.responseModel.cardList[i].recruiterName,
                });
              }
              if (prop.resumeDraftData.length > 1) {
                emit("jumpStep", 105, "", 4);
              } else {
                // 1 record only
                router.push({
                  name: "CCProgressRoutePage",
                  state: {
                    draftListing: true,
                  },
                  query: {
                    webFormRequestId: prop.resumeDraftData[0].webFormRequestId,
                  },
                });
              }
            }
          }
        }
      })
      .catch((e) => {
        emit("newApplication");
        emit("jumpStep", 1, "", 4);
      });
  } else {
    emit("jumpStep", 102, status, 4);
  }
};

const resumeApplication = () => {
  popoutDraftFound.value = false;
  if (prop.resumeDraftData.length > 1) {
    emit("jumpStep", 105, "", 4);
  } else {
    // 1 record only
    router.push({
      name: "CCProgressRoutePage",
      state: {
        draftListing: true,
      },
      query: {
        webFormRequestId: prop.resumeDraftData[0].webFormRequestId,
      },
    });
  }
};

const startNewApplication = () => {
  popoutDraftFound.value = false;
  const requestModel = {
    idType: prop.resumeInfo.idType,
    idNo: prop.resumeInfo.idNo,
    mobileCountryCode: prop.resumeInfo.countryCode,
    mobileNumber: prop.resumeInfo.mobileNo,
    emailAddress: prop.resumeInfo.email,
  };
  MasterService.searchCIF(requestModel)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.responseModel.cifVerify == "true") {
          // existing customer
          prop.ccFormValue.cifNo = res.data.responseModel.cifNo;
          emit("submit");
        } else {
          // non-existing customer
          emit("newApplication");
          emit("jumpStep", 1, "", 4);
        }
      }
    })
    .catch((e) => {
      emit("newApplication");
      emit("jumpStep", 1, "", 4);
    });
};
</script>

<style scoped>
.landingContainer {
  display: flex;
  gap: 40px;
}

.retrieveContainer:is(.Mobile) {
  width: 90%;
  padding: 80px 0;
}
.retrieveContainer.error {
  align-items: normal;
  padding: 40px;
}

.retrieveContainer:is(.Mobile).error {
  padding: 0;
}

.flex-container {
  margin: auto;
}

.loading {
  margin-bottom: 0;
  color: var(--Web-Black-High, #212121);
  text-align: center;

  /* H2 */
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */
}

.spinner-border {
  width: 5rem;
  height: 5rem;
}

.landingContainer:is(.Mobile) {
  display: block;
  padding: 0 16px;
}

.leftContainer {
  display: flex;
  width: 40%;
}

.leftContainer:is(.Mobile),
.rightContainer:is(.Mobile) {
  margin-top: -20px;
  width: 100%;
  padding: 0;
}

.rightContainer {
  width: 60%;
  padding: 50px 0;
}

.start_logo:is(.Mobile) {
  margin: auto;
  max-width: 240px;
}

.title {
  color: var(--Primary-Active, #ac2887);

  /* Custom 3 */
  font-family: Outfit;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 31.2px */
}

.title:is(.Mobile) {
  font-size: 24px;
}

.title2 {
  color: var(--Web-Black-Medium, #757575);

  /* H3 */
  font-family: Outfit;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 23.4px */
  margin-bottom: 16px;
}

.title:is(.Mobile),
.title2:is(.Mobile) {
  text-align: center;
}

.container1 {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: #f6f7f8;
}

.desc1 {
  color: var(--Web-Black-High, #212121);

  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.desc2 {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: var(--Web-Black-Medium, #757575);
  /* Subtitle 2 */
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
}

.buttoncontainer {
  align-items: center;
  margin-top: 24px;
  gap: 16px;
}

.sub_buttoncontainer {
  gap: 16px;
}

.buttoncontainer:is(.Mobile) {
  /* flex-wrap: wrap;
  display: flex;
  justify-content: space-between; */
  align-items: center;
  padding: 0;
}

.sub_buttoncontainer {
  display: flex;
  align-items: center;
}

.left-button {
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 1;
  text-align: center;
}

.left-button:disabled {
  background: #dedede;
  color: #fff;
  border: none;
}

/* .left-button:is(.Desktop, .Tablet) {
  flex: 0 0 30%;
  display: none;
} */

/* .left-button:is(.Mobile) {
  flex: 0 0 30%;
  display: none;
} */

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 1;
  margin-bottom: 16px;
}

/* .right-button:is(.Desktop, .Tablet) {
  flex: 0 0 68%;
} */

/* .right-button:is(.Mobile) {
  flex: 0 0 68%;
} */

@media (max-width: 841px) {
  .buttoncontainer {
    flex-flow: column-reverse;
    gap: 12px;
  }

  /* .left-button {
    margin-bottom: 16px;
  } */
}

@media (max-width: 930px) {
  .sub_buttoncontainer {
    display: grid;
  }
}
</style>
